module.exports = __webpack_public_path__ + "img/edit.95553a03.svg";